import axios from 'axios';

import config from 'utils/config';

import { REFUND_ACTION } from 'constants/payment';

import { CP_PAYMENT_STATUS_FAILURE, CP_PAYMENT_STATUS_SUCCESS, CP_SWIPED } from 'constants/customerPresent';

import { PRINTER_PECTABS_PRINT_COMMAND } from './printCommands';

const sharedPostRequestHeaders = {
  url: config('ATB_PRINT_SERVICE'),
  method: 'POST'
};

const findError = (responses) => responses.find((item) => item.data.printerStatus === 'Error');

const postPrinterStatusCheck = () =>
  Promise.all([
    axios({
      ...sharedPostRequestHeaders,
      data: {
        printcommand: PRINTER_PECTABS_PRINT_COMMAND
      }
    })
  ]);

const postAllPrintCommands = (printCommands) => {
  const arrayOfRequests = printCommands.map((printcommand) =>
    axios({
      ...sharedPostRequestHeaders,
      data: {
        printcommand
      }
    })
  );

  return Promise.all(arrayOfRequests);
};

const buildPectabCommand = (receiptInput) => {
  const isCustomerPresentDeclinedOrSwipedReceipt =
    receiptInput.action !== REFUND_ACTION &&
    ((receiptInput.paymentStatus === CP_PAYMENT_STATUS_SUCCESS && receiptInput.authMethod === CP_SWIPED) ||
      receiptInput.paymentStatus === CP_PAYMENT_STATUS_FAILURE);
  const pectabElements = isCustomerPresentDeclinedOrSwipedReceipt
    ? [
        'TK',
        'A',
        '01ZR1',
        'TK',
        '6X',
        '01ZR1',
        '02EUROSTAR INT LTD',
        '03Sales Voucher',
        '04Date:',
        `05${receiptInput.paymentDate}`,
        '06Time:',
        `07${receiptInput.paymentTime}`,
        `08Receipt:`,
        `09${'0'.repeat(5 - receiptInput.receiptNumber.length) + receiptInput.receiptNumber}`,
        `10${receiptInput.APACS50TN || ''}`,
        '11Card:',
        `12${receiptInput.cardType}`,
        '13MID:',
        `14${receiptInput.merchantId}`,
        '15Number:',
        `16${receiptInput.customerPan}`,
        `17${receiptInput.verification || receiptInput.cardType}`,
        '18TID:',
        `19${receiptInput.terminalId}`,
        '20Auth Code:',
        `21${receiptInput.approvalCode || 'Declined'}`,
        '22AID:',
        `23${receiptInput.aId}`,
        '24Issue/App:',
        `25${receiptInput.issueNumber}`,
        '26Amount:',
        `27${receiptInput.currency} ${receiptInput.amount}`,
        `28${receiptInput.customerName}`,
        '29Cardholder copy',
        `30${new Array(50).fill('.').join('')}`,
        '31Please retain for',
        '32your records',
        `33Booking Reference ${receiptInput.bookingReference}`
      ]
    : [
        'TK',
        'A',
        '01ZR1',
        'TK',
        '6X',
        '01ZR1',
        '02EUROSTAR INT LTD',
        '03Sales Voucher',
        '04Date:',
        `05${receiptInput.paymentDate}`,
        '06Time:',
        `07${receiptInput.paymentTime}`,
        '11Ref:',
        `12${receiptInput.paymentReference}`,
        '13MID:',
        `14${receiptInput.merchantId}`,
        '15Number:',
        `16${receiptInput.customerPan}`,
        `17${receiptInput.verification || receiptInput.cardType}`,
        '18TID:',
        `19${receiptInput.terminalId}`,
        '20Auth Code:',
        `21${receiptInput.approvalCode || 'Declined'}`,
        '22AID:',
        `23${receiptInput.aId}`,
        '26Amount:',
        `27${receiptInput.currency} ${receiptInput.amount}`,
        '28Action:',
        '29Status:',
        `30${receiptInput.action}`,
        `31${receiptInput.paymentStatus}`,
        `33Booking Reference ${receiptInput.bookingReference}`
      ];

  return `${pectabElements.join(';')};`;
};

const printReceipt = async (_, { receiptInput }) => {
  const responsesForPrinterStatusCheck = await postPrinterStatusCheck();

  if (findError(responsesForPrinterStatusCheck)) {
    return 'PRINTER_ERROR_STATUS_CHECK';
  }

  const pectabCommand = buildPectabCommand(receiptInput);

  const printResponse = await postAllPrintCommands([pectabCommand]);

  if (findError(printResponse)) {
    return 'PRINTER_ERROR';
  }

  return 'PRINTER_SUCCESS';
};

export default printReceipt;
